// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3nhpQ","buttons":"PendingPaymentAlert_buttons__1v3se"};